export default function jmaFormValidation() {
    $("#onboarding-jma-form").validate({
        errorElement: 'span',
        errorClass: 'help-block error-help-block',

        errorPlacement: function (error, element) {
            if (element.parent('.input-group').length ||
                element.prop('type') === 'checkbox' || element.prop('type') === 'radio') {
                error.insertAfter(element.parent());
            } else {
                error.insertAfter(element);
            }
        },
        highlight: function (element) {
            $(element).closest('.form-group').removeClass('has-success').addClass('has-error'); // add the Bootstrap error class to the control group
        },

        success: function (element) {
            $(element).closest('.form-group').removeClass('has-error').addClass('has-success'); // remove the Boostrap error class from the control group
        },

        submitHandler: function(form) {
            $('#JmaSubmitButton').prop('disabled', true);

            return form.submit()
        },

        focusInvalid: false,

        rules: {
            "address_1": {"laravelValidation": [["Required", [], "The address 1 field is required.", true]]},
            "city": {"laravelValidation": [["Required", [], "The city field is required.", true]]},
            "phone": {"laravelValidation": [["Required", [], "The phone field is required.", true]]},
            "state": {"laravelValidation": [["Required", [], "The state field is required.", true]]},
            "zip": {"laravelValidation": [["Required", [], "The zip field is required.", true]]},
            "dealer_name": {"laravelValidation": [["Required", [], "The dealer name field is required.", true]]},
            "jma_signer": {"laravelValidation": [["Required", [], "The Signer Name field is required.", true]]},
            "jma_signer_title": {"laravelValidation": [["Required", [], "The Signer Title field is required.", true]]},
            "jma_email": {"laravelValidation": [["Required", [], "The Signer Email is required.", true]]},
            "jma_signature_date": {"laravelValidation": [["Required", [], "The jma signature date field is required.", true]]},
            "jma_agreement": {"laravelValidation": [["Accepted", [], "The jma agreement must be accepted.", true]]}
        }
    });
}